/*
 * @Description: 404
 * @Author: yy
 * @Date: 2019-05-31 14:47:29
 * @LastEditors: yy
 * @LastEditTime: 2020-08-18 16:54:50
 */

import React from 'react';
import Layout from '../../components/Layout';
import NotFound from './NotFound';

const title = '404 没有找到这个页面';

export default {

  path: '*',

  action() {
    return {
      title,
      component: <Layout><NotFound title={title} /></Layout>,
      status: 404,
    };
  },

};



// WEBPACK FOOTER //
// src/routes/notFound/index.js